
import { defineComponent, onMounted, reactive, ref } from 'vue'
import Layout from './Layout.vue'
import BgSlot from '@/components/BgSlot.vue'
import TopBox from '@/components/ViewRecords/topBox.vue'
import List from '@/components/ViewRecords/List.vue'
import { onBeforeRouteLeave, useRoute } from 'vue-router'

import { Http } from '@/plugins/axios'
import { connectWallet } from '@/composables/metamask'
import Loading from '@/components/common/loading.vue'

interface IRedPackInfo {
  amount: string;
  chainId: string;
  count: number;
  decimal: number;
  denom: string;
  envelopeId: string;
  expiredDate: number;
  message: string;
  myReward: {
    amount: string;
    decimal: number;
    denom: string;
    owner: string;
    receiveDate: number;
  };
  receivedAmount: string;
  receivedCount: number;
  receivedList: {
    amount: string;
    best: boolean;
    decimal: number;
    demon: string;
    receiveDate: number;
    receiver: string;
  }[];
  sendDate: number;
  sender: string;
  status: number;
  title: string;
  type: string;
}

export default defineComponent({
  components: {
    Layout,
    BgSlot,
    TopBox,
    List,
    Loading
  },

  props: {
    // chainId: {
    //   type: Number,
    //   required: true
    // },
    // redPackId: {
    //   type: String,
    //   required: true
    // },
    // address: {
    //   type: String,
    //   required: true
    // }
  },
  setup (props) {
    const route = useRoute()

    const query = route.query as {
      redPackId: string;
      redPackTitle: string;
      skin: string;
    }

    const chainIdInit = ref()

    const redPackBasicInfo = reactive<IRedPackInfo>({
      amount: '',
      chainId: '',
      count: 0,
      decimal: 0,
      denom: '',
      envelopeId: '',
      expiredDate: 0,
      message: '',
      myReward: {
        amount: '0',
        decimal: 0,
        denom: '',
        owner: '',
        receiveDate: 0
      },
      receivedAmount: '',
      receivedCount: 0,
      receivedList: [],
      sendDate: 0,
      sender: '',
      status: 0,
      title: '',
      type: ''
    })

    async function getEnvelope (address: string) {
      const data = await Http.get<IRedPackInfo>({
        url: '/redenvelope/v1/envelope',
        params: {
          chainId: chainIdInit.value,
          envelopeId: query.redPackId,
          address
        }
      })

      redPackBasicInfo.amount = data.amount
      redPackBasicInfo.chainId = data.chainId
      redPackBasicInfo.receivedCount = data.receivedCount
      redPackBasicInfo.receivedList = data.receivedList
      redPackBasicInfo.sendDate = data.sendDate
      redPackBasicInfo.sender = data.sender
      redPackBasicInfo.status = data.status
      redPackBasicInfo.title = data.title
      redPackBasicInfo.type = data.type
      redPackBasicInfo.count = data.count
      redPackBasicInfo.decimal = data.decimal
      redPackBasicInfo.denom = data.denom
      redPackBasicInfo.envelopeId = data.envelopeId
      redPackBasicInfo.expiredDate = data.expiredDate
      redPackBasicInfo.message = data.message
      redPackBasicInfo.myReward = data.myReward
      redPackBasicInfo.receivedAmount = data.receivedAmount
    }

    onMounted(async () => {
      const { address, chainId } = await connectWallet()

      chainIdInit.value = chainId

      await getEnvelope(address)
    })

    // onBeforeRouteLeave((to, from, next) => {
    //   if (to.name === 'ReceiveRedPack') {
    //     next({ name: 'Home' })
    //   } else {
    //     next()
    //   }
    // })

    return {
      chainIdInit,
      redPackBasicInfo,
      query
    }
  }
})
